"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorPickerItemTooltipDataHook = exports.colorPickerItemDataHook = exports.colorPickerDataHook = void 0;
exports.colorPickerDataHook = 'ColorPicker';
exports.colorPickerItemDataHook = 'ColorPickerItem';
exports.colorPickerItemTooltipDataHook = 'color-picker-item-tooltip';
//# sourceMappingURL=dataHooks.js.map